import { User } from '../../models';

export interface IAuthState {
  user: User;
  token: string;
  refreshToken: string;
}

export const initialAuthState: IAuthState = {
  user: null,
  token: null,
  refreshToken: null,
};
